import Component from '~/components/component';
import Swiper, { Autoplay, Pagination } from 'swiper';

export default class ImagesSlider extends Component {
	constructor(...args) {
		super(...args);
		this._initDom();
		this.swiper = null;
	}

	_initDom() {
		this.dom.swiperContainer = this._find('.js-images-swiper');
		this.dom.pagination = this._find('.swiper-pagination');
	}

	init() {
		super.init();
		this._initSwiper();
	}

	_initSwiper() {
		if (this.dom.swiperContainer) {
			this.swiper = new Swiper(this.dom.swiperContainer, {
				modules: [Autoplay, Pagination],
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				slidesPerView: 1,
				loop: true,
				speed: 600,
				pagination: {
					el: this.dom.pagination,
					clickable: true,
				},
				breakpoints: {
					768: {
						autoplay: false,
						slidesPerView: 4,
						spaceBetween: 10,
						loop: false,
						allowTouchMove: false,
					},
				},
			});
		}
	}

	/*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}
